import { render, staticRenderFns } from "./student-date-of-birth.vue?vue&type=template&id=dea59980"
import script from "./student-date-of-birth.vue?vue&type=script&lang=js"
export * from "./student-date-of-birth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports